// extracted by mini-css-extract-plugin
module.exports = {"loadingTextBlock":"styles_loadingTextBlock__lbD6M","loadingTextBlockLine":"styles_loadingTextBlockLine__0oMGw"};